export enum ReleaseZoneProperties {
  Name = "name",
  Description = "description",
  Zone = "zone",
  IsRelease = "isRelease",
  Owner = "owner",
  Id = "id",
  Created = "created",
  Updated = "updated",
  Deleted = "deleted",
  Version = "version"
}
export enum ReleaseZoneMetaProperties {}
